import apiSportsSchools from '@/api/sports-schools'

const state = {
  isLoading: false,
  sportsSchool: null,
  validationErrors: null,
  isSubmitting: false
}

export const mutationTypes = {
  updateSportSchoolsStart: '[update sportsSchools] updateSportSchoolsStart',
  updateSportSchoolsSuccess: '[update sportsSchools] updateSportSchoolsSuccess',
  updateSportSchoolsFailure: '[update sportsSchools] updateSportSchoolsFailure',

  getSportSchoolsStart: '[update sportsSchools] getSportSchoolsStart',
  getSportSchoolsSuccess: '[update sportsSchools] getSportSchoolsSuccess',
  getSportSchoolsFailure: '[update sportsSchools] getSportSchoolsFailure'
}

export const actionType = {
  updateSportSchools: '[update sportsSchools] updateSportSchools',
  getSportSchools: '[update sportsSchools] getSportSchools'
}

const mutations = {
  [mutationTypes.updateSportSchoolsStart](state) {
    state.isSubmitting = true
    state.validationErrors = null
  },

  [mutationTypes.updateSportSchoolsSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.updateSportSchoolsFailure](state, payload) {
    state.isSubmitting = false
    state.validationErrors = payload
  },

  [mutationTypes.getSportSchoolsStart](state) {
    state.isLoading = true
    state.validationErrors = null
  },

  [mutationTypes.getSportSchoolsSuccess](state, payload) {
    state.isLoading = false
    state.sportsSchool = payload
  },

  [mutationTypes.getSportSchoolsFailure](state, payload) {
    state.isLoading = false
    state.validationErrors = payload
  }
}

const actions = {
  [actionType.getSportSchools](context, {id}) {
    context.commit(mutationTypes.getSportSchoolsStart)
    return new Promise(resolve => {
      apiSportsSchools
        .getSportSchool(id)
        .then(response => {
          context.commit(mutationTypes.getSportSchoolsSuccess, response.data)
          resolve(response.data)
        })
        .catch(result => {
          context.commit(mutationTypes.getSportSchoolsFailure, result.response)
        })
    })
  },

  [actionType.updateSportSchools](context, sport) {
    context.commit(mutationTypes.updateSportSchoolsStart)
    return new Promise(resolve => {
      apiSportsSchools
        .updateSportSchools(sport)
        .then(response => {
          context.commit(mutationTypes.updateSportSchoolsSuccess, response.data)
          resolve(response.data)
        })
        .catch(result => {
          context.commit(
            mutationTypes.updateSportSchoolsFailure,
            result.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
